import { tKey } from "ember-intl";

export const CONNECTION_TYPES = Object.freeze({
  PRIVATE: "privateNetwork",
  VLAN: "vlanNetwork",
  INTERNET: "internet",
});

export function getConnectionOptions(currentConnectionType) {
  return [
    {
      labelKey: tKey("component.modal.vmware-network-adapter-create.connection-options.private-network"),
      value: CONNECTION_TYPES.PRIVATE,
      checked: currentConnectionType === CONNECTION_TYPES.PRIVATE,
    },
    {
      labelKey: tKey("component.modal.vmware-network-adapter-create.connection-options.vlan-network"),
      value: CONNECTION_TYPES.VLAN,
      checked: currentConnectionType === CONNECTION_TYPES.VLAN,
    },
    {
      labelKey: tKey("component.modal.vmware-network-adapter-create.connection-options.internet"),
      value: CONNECTION_TYPES.INTERNET,
      checked: currentConnectionType === CONNECTION_TYPES.INTERNET,
    },
  ];
}

export function getConnectionConfig({
  selectedSegment,
  selectedVlanNetwork,
  cost,
  server,
  selectedBandwidth,
  connectionType,
}) {
  const configs = {
    [CONNECTION_TYPES.PRIVATE]: {
      isValid: () => !!selectedSegment,
      getCost: () => 0,
      getBandwidthOptions: () => [1000],
    },
    [CONNECTION_TYPES.VLAN]: {
      isValid: () => !!selectedVlanNetwork,
      getCost: () => cost.forNetworkAdapter(selectedBandwidth, server, selectedVlanNetwork),
      getBandwidthOptions: () => server.platformArguments.get("internalBandwidthOptions").map((option) => option.value),
    },
    [CONNECTION_TYPES.INTERNET]: {
      isValid: () => true,
      getCost: () => cost.forNetworkAdapter(selectedBandwidth, server),
      getBandwidthOptions: () => server.platformArguments.get("externalBandwidthOptions").map((option) => option.value),
    },
  };

  return configs[connectionType] || configs[CONNECTION_TYPES.INTERNET];
}

export function formatSegmentGroup(privateNetwork, filteredSegments) {
  return {
    label: `${privateNetwork.name} (${privateNetwork.id})`,
    options: filteredSegments.map((segment) => ({
      label: segment.name,
      value: segment.id,
    })),
  };
}

export function formatNetworkGroup(filteredNetworks) {
  return filteredNetworks.map((network) => ({
    label: `${network.description} (${network.id})`,
    value: network.id,
  }));
}
